import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IEnergyProducerUnit } from '../../entities/interfaces/energyProducerUnit';
import { detectDecimalSeparator } from '../../utils/utils';
import { Document } from '../../../jurisdiction/jurisdiction.domain';
import { GridApplicationDocumentTypes } from '../../entities/enums/grid-application-document-types.enum';
import { UICollectionTypes } from '../../entities/enums/ui-collection-types.enum';
import { NgForm, ControlContainer } from '@angular/forms';
import { FileEvent } from '../../../+shared/models/fileEvent';

@Component({
  selector: 'app-eproducer-unit-form-element',
  templateUrl: './eproducer-unit-form-element.component.html',
  styleUrls: ['./eproducer-unit-form-element.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class EproducerUnitFormElementComponent implements OnInit {
  @Input() energyUnit: IEnergyProducerUnit;
  @Input() index: number;
  @Input() type: string;
  @Input() isDetailsView: boolean;

  private _documents: Document[];
  public get documents(): Document[] {
    return this._documents;
  }
  @Input()
  public set documents(value: Document[]) {
    this._documents = value?.sort((a, b) => parseInt(b.document_id) - parseInt(a.document_id));
  }

  @Input() isDisabled: boolean;

  @Output() removeElementEvent = new EventEmitter<any>();
  @Output() maxPowerChangeEvent = new EventEmitter<any>();
  @Output() clearFileEvent = new EventEmitter<FileEvent>();

  public productDataSheet: Document;
  public unitCertificate: Document;
  public auditReport: Document;
  public documentTypes = GridApplicationDocumentTypes;
  public uiCollectionTypes = UICollectionTypes;

  constructor() {}

  ngOnInit(): void {
    if (this.documents) {
      this.productDataSheet = this.documents.find(x => x.sk_document_type === GridApplicationDocumentTypes.EnergyUnitDataSheet);
      this.unitCertificate = this.documents.find(x => x.sk_document_type === GridApplicationDocumentTypes.UnitCertificate);
      this.auditReport = this.documents.find(x => x.sk_document_type === GridApplicationDocumentTypes.AuditReport);
    }
  }

  public removeElement(element: any): void {
    this.removeElementEvent.emit({ element, type: this.type });
  }

  public maxPowerChange(maxPowerValue: number): void {
    if (maxPowerValue > 52 && this.documents.length === 2) {
      this.documents.push(new Document(GridApplicationDocumentTypes.AuditReport));
      this.auditReport = this.documents.find(d => d.sk_document_type === GridApplicationDocumentTypes.AuditReport);
    } else if (maxPowerValue <= 52 && this.documents.length === 3) {
      this.documents.splice(this.documents.length - 1, 1);
    }

    this.maxPowerChangeEvent.emit(true);
  }

  public identicalUnitsChange(): void {
    this.maxPowerChangeEvent.emit(true);
  }

  public detectDecimalSeparator = detectDecimalSeparator;

  public clearFile(fileEvent: FileEvent): void {
    this.clearFileEvent.emit(fileEvent);
  }
}
